// Фото и видео бронирования → кадры MediaLightbox. Порядок и длина совпадают с
// исходным массивом: лайтбокс открывается по индексу сетки.
export function isVideo(item) {
  return Boolean(item && item.content_type && item.content_type.split("/")[0] === "video");
}

export function toLightboxItems(photos) {
  return (photos || []).map((item) => ({
    type: isVideo(item) ? "video" : "image",
    src: item.url,
    contentType: item.content_type,
  }));
}
